/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface TagEditorDropdownItemArgs {
  item: {
    __customvalue__: boolean;
    value: string | number;
    label: string;
  };
}

export default class TagEditorDropdownItem extends Component<TagEditorDropdownItemArgs> {}
